import * as React from "react";

export const Copyright = () => {
    const org = process.env.ORGANISATION_NAME || "";
    const dateFrom = Number.parseInt(
        process.env.COPYRIGHT_FROM || new Date().getFullYear().toString(),
        10
    );
    const thisYear = new Date().getFullYear();
    const years =
        dateFrom === thisYear
            ? thisYear.toString()
            : `${dateFrom} - ${thisYear}`;

    return (
        <div className="copyright" data-testid="copyright">
            {" "}
            <p className="copyright-text" data-testid="copyright-year">
                © Copyright {org} {years}.
            </p>
            <p className="copyright-text">All rights reserved.</p>
            <p className="copyright-text">
                {process.env.DEVELOPER_LINK && (
                    <a
                        data-testid="developer"
                        className="copyright-link"
                        href={process.env.DEVELOPER_LINK}
                        target="_blank"
                        rel="noreferrer">
                        Nā {process.env.DEVELOPER_NAME} tēnei paetukutuku
                    </a>
                )}
                {process.env.PHOTOGRAPHY_LINK && (
                    <span>
                        &nbsp;&#124;&nbsp;
                        <a
                            data-testid="photographer"
                            className="copyright-link"
                            href={process.env.PHOTOGRAPHY_LINK}
                            target="_blank"
                            rel="noreferrer">
                            Nā {process.env.PHOTOGRAPHY_NAME} ngā whakaahua
                        </a>
                    </span>
                )}
            </p>
        </div>
    );
};
